import React from "react";

import fetcher from "../../../fetcher";
import {CustomerDisclosurePDF} from "../../DealPage/DisclosurePDFs/Customer/Lease/CustomerDisclosurePDF";
import {pdf, renderToFile} from "@react-pdf/renderer";
import {PurchaseCustomerDisclosurePDF} from "../../DealPage/DisclosurePDFs/Customer/Purchase/PurchaseCustomerDisclosurePDF";


const getFileName = (carDetail) => {
    return `${carDetail.year}-${carDetail.make}-${carDetail.model}-${carDetail.trim}.pdf`
}
export const getQuotesDataAndPDFs = async (quoteIds, recipient, companyName, dealState) => {
    let attachments = []
    let headerHTMLString = `<h3>Hi ${recipient},</h3>
    <p>Please review the following quotes and the attached documents: </p>
    `

    let bodyHTMLString = ""

    let footerHTMLString = "<p>Please let me know if any of these quotes interest you.</p>"

    for (let i = 0; i < quoteIds.length; i++) {
        let response = await fetcher.getDeal(quoteIds[i])
        let pdfResponse = await fetcher.getPDF(quoteIds[i])
        const deal = response.data
        const car_detail = deal.car_detail

        const doc = dealState.is_purchase ?
            (<PurchaseCustomerDisclosurePDF
                initialPDFState={pdfResponse?.data}
                dealState={dealState}
                customerName={recipient}
                companyName={companyName}
            />)
            : (<CustomerDisclosurePDF
                initialPDFState={pdfResponse?.data}
                dealState={dealState}
                customerName={recipient}
                companyName={companyName}
            />)
        const pdfFile =  await pdf(doc).toBlob();
        const file = new File([pdfFile], getFileName(deal.car_detail), { type: "application/pdf" })

        attachments.push(file)

        bodyHTMLString += `
            <strong>
                ${car_detail.year} ${car_detail.make} ${car_detail.model} ${car_detail.trim}
            </strong>
            <span>Monthly Payment: ${deal.formatted_quote.monthly_payment}</span>
            </br>
        `
    }

    const content = headerHTMLString + bodyHTMLString + footerHTMLString

    return {content, attachments}
}